export default {
  xs: 12,
  md: 6,
  xl: 4,
};
